import {createSelector} from 'reselect';

const getRoot = state => state;
const getState = createSelector(getRoot, state => state.customerDealer);
export const getSelectedDealer = createSelector(getState, ({selectedDealer}) => selectedDealer);
export const getSelectedDealerId = createSelector(getSelectedDealer, (selectedDealer = {}) => (selectedDealer).id);
export const isLoadingSelectedDealer = createSelector(getState, ({loading}) => loading);



// WEBPACK FOOTER //
// ./src/selectors/customerDealer.js